import { Box, styled } from '@mui/material';
import { LoadingImage, LulaLogoDark } from '@app/icons';
import * as React from 'react';

const RotatingLoadingImage = styled(LoadingImage)`
  animation: rotate 2s linear infinite;
  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
`;

export function Loading() {
  return (
    <>
      <Box
        alignItems="center"
        display="flex"
        flexGrow={1}
        justifyContent="center"
        py={10}
      >
        <Box
          display="flex"
          sx={{
            position: 'relative',
            width: 180,
            height: 180,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <RotatingLoadingImage />
          </Box>
          <Box
            sx={{
              display: 'flex',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <LulaLogoDark height="80px" width="80px" />
          </Box>
        </Box>
      </Box>
    </>
  );
}
